import React from 'react'
import { Route } from 'react-router-dom'
import { OrganizationList } from './page/organization-list'
import { OrganizationAdd } from './page/organization-add'
import { OrganizationEdit } from './page/organization-edit'
import { OrganizationSso } from './page/organization-edit/organization-sso'
import { OrganizationRecycle } from './page/organization-recycle'
import { OrganizationExtend } from './page/organization-extend'
import { Delete } from '../../../../shared/page/page-delete'
import { Purge } from '../../../../shared/page/page-purge'
import { useApiFormOrganization } from '../../../../api-new/state/content'

export const LayoutOrganization = () => {
  return (
    <React.Fragment>
      <Route path="/admin/organization/list" component={OrganizationList} />
      <Route path="/admin/organization/list/add" component={OrganizationAdd} />
      <Route path="/admin/organization/list/edit/:organizationID" component={OrganizationEdit} />
      <Route path="/admin/organization/list/edit/:organizationID/sso" component={OrganizationSso} />
      <Route path="/admin/organization/list/edit/:deleteID/delete">
        <Delete useApiForm={useApiFormOrganization} titleParam="name" successPath="/admin/organization/list" />
      </Route>
      <Route path="/admin/organization/list/recycle" component={OrganizationRecycle} />
      <Route path="/admin/organization/list/recycle/purge/:purgeID">
        <Purge
          useApiForm={useApiFormOrganization}
          titleParam="name"
          successPath="/admin/organization/list/recycle"
          showServerError
          buttonText="purge now"
          successMessage="Purge scheduled. The hourly job will purge it."
        />
      </Route>
      <Route path="/admin/organization/list/recycle/extend/:extendID" component={OrganizationExtend} />
    </React.Fragment>
  )
}
